import { render, staticRenderFns } from "./user-transaction.vue?vue&type=template&id=1c19fabe&scoped=true"
import script from "./user-transaction.vue?vue&type=script&lang=js"
export * from "./user-transaction.vue?vue&type=script&lang=js"
import style0 from "./user-transaction.vue?vue&type=style&index=0&id=1c19fabe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c19fabe",
  null
  
)

export default component.exports